import React from 'react';

import { Page } from '../../../../../shared/ui/Page';
import { ApiKeysEditContainer } from '../containers/ApiKeysEditContainer';

export const ApiKeysSettingsPage = () => {
    return (
        <Page isBackButton title={'API ключи'}>
            <ApiKeysEditContainer />
        </Page>
    );
};
